export default {
  title: 'Agency Management',
  menu: 'Agency Management',
  agencyAdd: 'Add Agency',
  agencyEdit: 'Edit Agency',
  label: {
    name: 'Name',
    email: 'Email Address',
    notes: 'Agency Name',
    status: 'Status'
  },
  placeholder: {

  },
  btn: {
    cancel: 'Cancel',
    confirm: 'Save',
    addAgency: 'Add Agency'
  },
  message: {
  }
}
